// ZZYON LEX — painéis do detalhe do processo (Fase A da plataforma de soluções).
// 5 painéis: Análise de risco · Fato gerador · Pessoas (RACI) · Documentos · Plano de ação.
//
// Tudo manual nessa fase — Fase B vai trazer agentes IA preenchendo automaticamente.

import {
  fetchAnaliseAtual, salvarAnalise,
  fetchProcessoPessoas, atribuirPessoa, removerPessoaProcesso, fetchPessoas, criarPessoa,
  fetchProcessoDocs, criarDoc, atualizarDoc, removerDoc,
  fetchProcessoAcoes, criarAcao, atualizarAcao, concluirAcao, removerAcao,
} from './lex-client.js';
import { openModal, closeModal } from './lex-modal.js';
import { abrirAnalisarComIA } from './lex-ia-analise.js';
import { escapeHtml, fmtBRL, fmtDate, fromNow, riscoBadge } from './utils.js';

// ─── Renderer principal ─────────────────────────────────────────────────
export async function renderPaineisProcesso(host, processo, currentUserEmail) {
  host.innerHTML = `
    <div id="lex-pn-analise"></div>
    <div id="lex-pn-pessoas"></div>
    <div id="lex-pn-docs"></div>
    <div id="lex-pn-acoes"></div>
  `;
  await Promise.all([
    renderAnalise(host.querySelector('#lex-pn-analise'), processo, currentUserEmail),
    renderPessoas(host.querySelector('#lex-pn-pessoas'), processo),
    renderDocs(host.querySelector('#lex-pn-docs'), processo),
    renderAcoes(host.querySelector('#lex-pn-acoes'), processo, currentUserEmail),
  ]);
}

const $ = (sel, root) => root.querySelector(sel);
const $$ = (sel, root) => Array.from(root.querySelectorAll(sel));

// ════════════════════════════════════════════════════════════════════════
// 1. ANÁLISE DE RISCO + FATO GERADOR
// ════════════════════════════════════════════════════════════════════════
async function renderAnalise(host, processo, userEmail) {
  const a = await fetchAnaliseAtual(processo.id);
  host.innerHTML = `
    <div class="lex-section">
      <h2>
        Análise de risco e fato gerador
        <span class="count">${a ? `v${a.versao}` : 'sem análise'}</span>
        ${a?.validado_por_advogado
          ? `<span class="lex-badge lex-badge-ok" style="margin-left:6px">VALIDADO</span>`
          : (a ? `<span class="lex-badge lex-badge-warn" style="margin-left:6px">PRELIMINAR</span>` : '')}
      </h2>
      <div style="padding:18px 20px">
        ${a ? renderAnaliseLeitura(a) : `
          <div class="lex-empty">
            Sem análise registrada. Use o botão abaixo para criar a primeira.
          </div>`}
        <div style="margin-top:14px;display:flex;gap:10px;flex-wrap:wrap">
          <button class="lex-btn-secondary" data-act="edit-analise">
            ${a ? 'Atualizar análise' : 'Criar análise'}
          </button>
          <button class="lex-btn-secondary" data-act="analise-ia"
                  style="border-color:var(--lex-bronze);background:var(--lex-bronze-soft)">
            ⚡ Analisar com IA (PDF da petição)
          </button>
        </div>
      </div>
    </div>
  `;
  $('[data-act="edit-analise"]', host).addEventListener('click', () => {
    abrirFormAnalise(processo, a, userEmail, () => renderAnalise(host, processo, userEmail));
  });
  $('[data-act="analise-ia"]', host).addEventListener('click', () => {
    abrirAnalisarComIA(processo, userEmail, () => {
      // Atualiza análise + refresh dos painéis irmãos
      const root = host.parentElement;
      renderAnalise(host, processo, userEmail);
      const docs = root?.querySelector('#lex-pn-docs');
      const acoes = root?.querySelector('#lex-pn-acoes');
      if (docs) renderDocs(docs, processo);
      if (acoes) renderAcoes(acoes, processo, userEmail);
    });
  });
}

function renderAnaliseLeitura(a) {
  const r = riscoBadge(a.risco);
  return `
    <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(200px,1fr));gap:14px;margin-bottom:18px">
      <div><div class="lex-key">Risco</div><div><span class="${r.cls}" style="margin-top:4px">${r.txt}</span></div></div>
      <div><div class="lex-key">Condenação esperada</div><div class="lex-val">${fmtBRL(a.valor_condenacao_estimado)}</div></div>
      <div><div class="lex-key">Acordo aceitável</div><div class="lex-val">${fmtBRL(a.valor_acordo_aceitavel)}</div></div>
      <div><div class="lex-key">Provisão recomendada</div><div class="lex-val">${fmtBRL(a.valor_provisao_recomendado)}</div></div>
    </div>
    ${a.risco_justificativa ? `
      <div style="margin-bottom:14px">
        <div class="lex-key">Justificativa do risco</div>
        <div class="lex-val" style="white-space:pre-wrap">${escapeHtml(a.risco_justificativa)}</div>
      </div>` : ''}
    ${a.fato_gerador_resumo ? `
      <div style="margin-bottom:14px">
        <div class="lex-key">Fato gerador</div>
        <div class="lex-val" style="white-space:pre-wrap">${escapeHtml(a.fato_gerador_resumo)}</div>
        ${a.fato_gerador_data || a.fato_gerador_local ? `
          <div style="font-size:12px;color:rgba(255,255,255,0.55);margin-top:4px">
            ${a.fato_gerador_data ? `Data: ${fmtDate(a.fato_gerador_data)}` : ''}
            ${a.fato_gerador_local ? ` · Local: ${escapeHtml(a.fato_gerador_local)}` : ''}
          </div>` : ''}
      </div>` : ''}
    ${a.estrategia_defesa ? `
      <div style="margin-bottom:14px">
        <div class="lex-key">Estratégia de defesa</div>
        <div class="lex-val" style="white-space:pre-wrap">${escapeHtml(a.estrategia_defesa)}</div>
      </div>` : ''}
    ${!a.validado_por_advogado ? `
      <div class="lex-disclaimer">
        Análise <strong>preliminar</strong>, não validada por advogado. Não usar para
        decisão financeira (provisão DRE, aprovação de acordo) sem validação formal.
      </div>` : ''}
  `;
}

function abrirFormAnalise(processo, atual, userEmail, onDone) {
  const form = document.createElement('form');
  form.innerHTML = `
    <div class="lex-form-grid">
      <div class="lex-field">
        <label>Risco <span class="req">*</span></label>
        <select name="risco" required>
          <option value="">—</option>
          <option value="provavel" ${atual?.risco === 'provavel' ? 'selected' : ''}>Provável</option>
          <option value="possivel" ${atual?.risco === 'possivel' ? 'selected' : ''}>Possível</option>
          <option value="remoto"   ${atual?.risco === 'remoto' ? 'selected' : ''}>Remoto</option>
          <option value="sem_classificacao" ${atual?.risco === 'sem_classificacao' ? 'selected' : ''}>Sem classificação</option>
        </select>
      </div>
      <div class="lex-field">
        <label>Condenação esperada (R$)</label>
        <input type="number" name="valor_condenacao_estimado" step="0.01" value="${atual?.valor_condenacao_estimado ?? ''}" />
      </div>
      <div class="lex-field">
        <label>Acordo aceitável (R$)</label>
        <input type="number" name="valor_acordo_aceitavel" step="0.01" value="${atual?.valor_acordo_aceitavel ?? ''}" />
      </div>
      <div class="lex-field">
        <label>Provisão recomendada (R$)</label>
        <input type="number" name="valor_provisao_recomendado" step="0.01" value="${atual?.valor_provisao_recomendado ?? ''}" />
      </div>
      <div class="lex-field lex-field--full">
        <label>Justificativa do risco</label>
        <textarea name="risco_justificativa" rows="3" placeholder="Por que esse risco? Cite jurisprudência, prova documental, vulnerabilidade.">${escapeHtml(atual?.risco_justificativa || '')}</textarea>
      </div>
      <div class="lex-field lex-field--full">
        <label>Fato gerador (resumo)</label>
        <textarea name="fato_gerador_resumo" rows="3" placeholder="O que aconteceu na operação que originou a ação?">${escapeHtml(atual?.fato_gerador_resumo || '')}</textarea>
      </div>
      <div class="lex-field">
        <label>Data do fato</label>
        <input type="date" name="fato_gerador_data" value="${atual?.fato_gerador_data || ''}" />
      </div>
      <div class="lex-field">
        <label>Local / contexto</label>
        <input type="text" name="fato_gerador_local" placeholder="Filial, rota, depósito" value="${escapeHtml(atual?.fato_gerador_local || '')}" />
      </div>
      <div class="lex-field lex-field--full">
        <label>Estratégia de defesa</label>
        <textarea name="estrategia_defesa" rows="3" placeholder="Linha de defesa, teses, argumentos centrais.">${escapeHtml(atual?.estrategia_defesa || '')}</textarea>
      </div>
    </div>
  `;

  const foot = document.createElement('div');
  foot.style.cssText = 'display:contents';
  foot.innerHTML = `
    <button type="button" class="lex-btn-secondary" data-act="cancel">Cancelar</button>
    <button type="submit" class="lex-btn" style="width:auto;padding:10px 18px">Salvar versão</button>
  `;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const fd = new FormData(form);
    const num = (k) => fd.get(k) ? Number(fd.get(k)) : null;
    const txt = (k) => (fd.get(k) || '').trim() || null;
    const payload = {
      processo_id: processo.id,
      origem: 'manual',
      risco: txt('risco'),
      risco_justificativa: txt('risco_justificativa'),
      valor_condenacao_estimado: num('valor_condenacao_estimado'),
      valor_acordo_aceitavel: num('valor_acordo_aceitavel'),
      valor_provisao_recomendado: num('valor_provisao_recomendado'),
      fato_gerador_resumo: txt('fato_gerador_resumo'),
      fato_gerador_data: txt('fato_gerador_data'),
      fato_gerador_local: txt('fato_gerador_local'),
      estrategia_defesa: txt('estrategia_defesa'),
      criado_por_email: userEmail,
    };
    try {
      await salvarAnalise(payload);
      closeModal();
      onDone();
    } catch (err) {
      alert('Erro: ' + (err.message || err));
    }
  });
  foot.querySelector('[data-act="cancel"]').addEventListener('click', closeModal);

  openModal({
    title: atual ? `Atualizar análise (versão ${atual.versao + 1})` : 'Criar análise de risco',
    body: form, footer: foot, wide: true,
  });
}

// ════════════════════════════════════════════════════════════════════════
// 2. PESSOAS (RACI)
// ════════════════════════════════════════════════════════════════════════
const RESPONSABILIDADES = [
  { v: 'gestor',      label: 'Gestor (Accountable)' },
  { v: 'advogado',    label: 'Advogado (Responsible)' },
  { v: 'rh',          label: 'RH (Consulted)' },
  { v: 'operacional', label: 'Operacional / Filial (Consulted)' },
  { v: 'financeiro',  label: 'Financeiro (Consulted)' },
  { v: 'informado',   label: 'Informado (Diretoria)' },
];
const RESP_LABEL = Object.fromEntries(RESPONSABILIDADES.map(r => [r.v, r.label]));

async function renderPessoas(host, processo) {
  const rows = await fetchProcessoPessoas(processo.id);
  host.innerHTML = `
    <div class="lex-section">
      <h2>Pessoas envolvidas <span class="count">${rows.length}</span></h2>
      <div style="padding:14px 20px">
        ${rows.length ? `
          <table class="lex-table" style="font-size:13px">
            <thead><tr>
              <th>Nome</th><th>Papel</th><th>Responsabilidade</th><th>Contato</th><th></th>
            </tr></thead>
            <tbody>
              ${rows.map(r => `
                <tr>
                  <td><strong>${escapeHtml(r.pessoa?.nome || '—')}</strong>
                    ${r.pessoa?.organizacao ? `<br><span style="color:rgba(255,255,255,0.55);font-size:11px">${escapeHtml(r.pessoa.organizacao)}</span>` : ''}
                  </td>
                  <td>${escapeHtml(r.pessoa?.papel || '—')}</td>
                  <td><span class="lex-badge lex-badge-bronze">${escapeHtml(RESP_LABEL[r.responsabilidade] || r.responsabilidade)}</span></td>
                  <td style="font-size:11px;color:rgba(255,255,255,0.7)">
                    ${r.pessoa?.email ? `<div>${escapeHtml(r.pessoa.email)}</div>` : ''}
                    ${r.pessoa?.whatsapp ? `<div>${escapeHtml(r.pessoa.whatsapp)}</div>` : ''}
                  </td>
                  <td><button class="lex-btn-secondary" style="padding:5px 10px;font-size:11px" data-rm="${r.id}">remover</button></td>
                </tr>`).join('')}
            </tbody>
          </table>
        ` : `<div class="lex-empty">Nenhuma pessoa atribuída a este processo.</div>`}
        <div style="margin-top:14px">
          <button class="lex-btn-secondary" data-act="add-pessoa">+ Atribuir pessoa</button>
        </div>
      </div>
    </div>
  `;

  $$('[data-rm]', host).forEach(btn => btn.addEventListener('click', async () => {
    if (!confirm('Remover esta pessoa do processo?')) return;
    await removerPessoaProcesso(btn.dataset.rm);
    renderPessoas(host, processo);
  }));

  $('[data-act="add-pessoa"]', host).addEventListener('click', () => {
    abrirFormAtribuirPessoa(processo, () => renderPessoas(host, processo));
  });
}

async function abrirFormAtribuirPessoa(processo, onDone) {
  const pessoas = await fetchPessoas();
  const form = document.createElement('form');
  form.innerHTML = `
    <div class="lex-form-grid">
      <div class="lex-field lex-field--full">
        <label>Pessoa <span class="req">*</span></label>
        <select name="pessoa_id" required>
          <option value="">— escolha —</option>
          ${pessoas.map(p => `<option value="${p.id}">${escapeHtml(p.nome)} · ${escapeHtml(p.papel || '')}${p.organizacao ? ' (' + escapeHtml(p.organizacao) + ')' : ''}</option>`).join('')}
        </select>
        ${pessoas.length === 0 ? `<small class="hint" style="color:#FFC44D">Nenhuma pessoa cadastrada ainda. Use o botão abaixo para criar a primeira.</small>` : ''}
      </div>
      <div class="lex-field">
        <label>Responsabilidade <span class="req">*</span></label>
        <select name="responsabilidade" required>
          ${RESPONSABILIDADES.map(r => `<option value="${r.v}">${r.label}</option>`).join('')}
        </select>
      </div>
      <div class="lex-field lex-field--full">
        <label>Observação</label>
        <input type="text" name="observacao" placeholder="ex: cuida da coleta de holerites" />
      </div>
    </div>
    <div style="margin-top:18px;padding-top:14px;border-top:1px solid rgba(255,255,255,0.08)">
      <strong style="font-size:12px;color:rgba(255,255,255,0.7);text-transform:uppercase;letter-spacing:0.08em">Cadastrar nova pessoa</strong>
      <div class="lex-form-grid" style="margin-top:10px">
        <div class="lex-field"><label>Nome</label><input name="np_nome" type="text" /></div>
        <div class="lex-field"><label>Papel</label>
          <select name="np_papel">
            <option value="">—</option>
            <option value="advogado_interno">advogado interno</option>
            <option value="advogado_externo">advogado externo</option>
            <option value="rh">rh</option>
            <option value="diretoria">diretoria</option>
            <option value="lider_filial">líder de filial</option>
            <option value="financeiro">financeiro</option>
            <option value="outro">outro</option>
          </select>
        </div>
        <div class="lex-field"><label>E-mail</label><input name="np_email" type="email" /></div>
        <div class="lex-field"><label>WhatsApp</label><input name="np_whatsapp" type="text" placeholder="5547999999999" /></div>
        <div class="lex-field lex-field--full"><label>Organização</label><input name="np_org" type="text" placeholder="Ossowski, Ícaro Express, etc." /></div>
      </div>
    </div>
  `;
  const foot = document.createElement('div');
  foot.style.cssText = 'display:contents';
  foot.innerHTML = `
    <button type="button" class="lex-btn-secondary" data-act="cancel">Cancelar</button>
    <button type="submit" class="lex-btn" style="width:auto;padding:10px 18px">Atribuir</button>
  `;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const fd = new FormData(form);
    let pessoaId = fd.get('pessoa_id');
    try {
      // se preencheu nova pessoa, cria primeiro
      if (!pessoaId && fd.get('np_nome')) {
        const nova = await criarPessoa({
          nome: fd.get('np_nome'),
          papel: fd.get('np_papel') || null,
          email: fd.get('np_email') || null,
          whatsapp: fd.get('np_whatsapp') || null,
          organizacao: fd.get('np_org') || null,
        });
        pessoaId = nova.id;
      }
      if (!pessoaId) {
        alert('Escolha uma pessoa ou cadastre uma nova.');
        return;
      }
      await atribuirPessoa({
        processo_id: processo.id,
        pessoa_id: pessoaId,
        responsabilidade: fd.get('responsabilidade'),
        observacao: fd.get('observacao') || null,
      });
      closeModal();
      onDone();
    } catch (err) {
      alert('Erro: ' + (err.message || err));
    }
  });
  foot.querySelector('[data-act="cancel"]').addEventListener('click', closeModal);

  openModal({ title: 'Atribuir pessoa ao processo', body: form, footer: foot, wide: true });
}

// ════════════════════════════════════════════════════════════════════════
// 3. DOCUMENTOS
// ════════════════════════════════════════════════════════════════════════
const STATUS_DOC = {
  pendente:       { cls: 'lex-badge lex-badge-warn', txt: 'PENDENTE' },
  em_coleta:      { cls: 'lex-badge lex-badge-info', txt: 'EM COLETA' },
  anexado:        { cls: 'lex-badge lex-badge-ok',   txt: 'ANEXADO' },
  indisponivel:   { cls: 'lex-badge lex-badge-crit', txt: 'INDISPONÍVEL' },
  nao_aplicavel:  { cls: 'lex-badge lex-badge-info', txt: 'N/A' },
};

async function renderDocs(host, processo) {
  const rows = await fetchProcessoDocs(processo.id);
  const obrPend = rows.filter(d => d.obrigatorio && d.status === 'pendente').length;

  host.innerHTML = `
    <div class="lex-section">
      <h2>
        Documentos para mitigação de risco
        <span class="count">${rows.length}</span>
        ${obrPend > 0 ? `<span class="lex-badge lex-badge-warn" style="margin-left:6px">${obrPend} obrigatório(s) pendente(s)</span>` : ''}
      </h2>
      <div style="padding:14px 20px">
        ${rows.length ? `
          <table class="lex-table" style="font-size:13px">
            <thead><tr>
              <th>Documento</th><th>Categoria</th><th>Responsável</th>
              <th>Prazo</th><th>Status</th><th></th>
            </tr></thead>
            <tbody>
              ${rows.map(d => {
                const st = STATUS_DOC[d.status] || STATUS_DOC.pendente;
                return `
                  <tr>
                    <td>
                      <strong>${escapeHtml(d.titulo)}</strong>
                      ${d.obrigatorio ? '<span class="lex-badge lex-badge-bronze" style="margin-left:6px">obrigatório</span>' : ''}
                      ${d.descricao ? `<br><span style="color:rgba(255,255,255,0.55);font-size:11px">${escapeHtml(d.descricao)}</span>` : ''}
                    </td>
                    <td>${escapeHtml(d.categoria || '—')}</td>
                    <td>${escapeHtml(d.responsavel?.nome || '—')}</td>
                    <td>${fmtDate(d.prazo)}</td>
                    <td><span class="${st.cls}">${st.txt}</span></td>
                    <td style="white-space:nowrap">
                      <button class="lex-btn-secondary" style="padding:5px 10px;font-size:11px" data-edit="${d.id}">editar</button>
                      <button class="lex-btn-secondary" style="padding:5px 10px;font-size:11px;border-color:#FF8C8C;color:#FF8C8C" data-rm="${d.id}">×</button>
                    </td>
                  </tr>`;
              }).join('')}
            </tbody>
          </table>
        ` : `<div class="lex-empty">Nenhum documento listado. Adicione os primeiros usando o botão abaixo.</div>`}
        <div style="margin-top:14px;display:flex;gap:10px;flex-wrap:wrap">
          <button class="lex-btn-secondary" data-act="add-doc">+ Documento</button>
          <button class="lex-btn-secondary" data-act="seed-trabalhista" title="Adiciona checklist típico de defesa trabalhista">⚡ Checklist trabalhista</button>
        </div>
      </div>
    </div>
  `;

  $$('[data-rm]', host).forEach(btn => btn.addEventListener('click', async () => {
    if (!confirm('Remover este documento?')) return;
    await removerDoc(btn.dataset.rm);
    renderDocs(host, processo);
  }));
  $$('[data-edit]', host).forEach(btn => btn.addEventListener('click', () => {
    const doc = rows.find(r => r.id === btn.dataset.edit);
    abrirFormDoc(processo, doc, () => renderDocs(host, processo));
  }));
  $('[data-act="add-doc"]', host).addEventListener('click', () =>
    abrirFormDoc(processo, null, () => renderDocs(host, processo))
  );
  $('[data-act="seed-trabalhista"]', host).addEventListener('click', async () => {
    if (!confirm('Adicionar 12 documentos típicos de defesa trabalhista?')) return;
    await seedTrabalhista(processo);
    renderDocs(host, processo);
  });
}

async function seedTrabalhista(processo) {
  const TEMPLATE = [
    { categoria: 'contratual', titulo: 'Contrato de trabalho assinado', descricao: 'Identifica vínculo, função, salário e cláusulas específicas (jornada, comissões).' },
    { categoria: 'contratual', titulo: 'TRCT e instrumento de rescisão', descricao: 'Termo de rescisão homologado. Comprova verbas pagas.' },
    { categoria: 'jornada', titulo: 'Cartões de ponto / batidas eletrônicas', descricao: 'Período integral do contrato. Para motorista: diário de bordo + Lei 13.103.' },
    { categoria: 'jornada', titulo: 'Acordo de banco de horas / compensação', descricao: 'Quando aplicável. Comprovante de homologação sindical.' },
    { categoria: 'jornada', titulo: 'Espelho da CCT vigente', descricao: 'SETCESC / FETCESP / sindicato local. Cláusulas de jornada e adicional.' },
    { categoria: 'financeiro', titulo: 'Holerites do período', descricao: 'Todas as competências reclamadas. Verifica horas extras já pagas.' },
    { categoria: 'financeiro', titulo: 'GFIP / SEFIP do período', descricao: 'Comprova depósitos de FGTS e contribuições.' },
    { categoria: 'medico', titulo: 'ASOs (admissional, periódico, demissional)', descricao: 'Programa de Controle Médico (PCMSO). Crítico em alegação de doença ocupacional.' },
    { categoria: 'medico', titulo: 'PPP (Perfil Profissiográfico)', descricao: 'Riscos ocupacionais a que o empregado foi exposto. Suporta defesa de adicional de insalubridade.' },
    { categoria: 'medico', titulo: 'CAT (se houver acidente)', descricao: 'Comunicação de Acidente do Trabalho registrada no e-Social.' },
    { categoria: 'operacional', titulo: 'Manifestos / CT-es do motorista', descricao: 'Quando reclamante é motorista. Cruza jornada com viagens reais.' },
    { categoria: 'operacional', titulo: 'Comprovantes de EPIs entregues', descricao: 'Lista de EPIs com assinatura. Mitiga insalubridade/periculosidade.' },
  ];
  const baseOrdem = (await fetchProcessoDocs(processo.id)).length;
  for (let i = 0; i < TEMPLATE.length; i++) {
    await criarDoc({
      processo_id: processo.id,
      ordem: baseOrdem + i,
      categoria: TEMPLATE[i].categoria,
      titulo: TEMPLATE[i].titulo,
      descricao: TEMPLATE[i].descricao,
      obrigatorio: true,
      status: 'pendente',
    });
  }
}

function abrirFormDoc(processo, atual, onDone) {
  const form = document.createElement('form');
  form.innerHTML = `
    <div class="lex-form-grid">
      <div class="lex-field lex-field--full">
        <label>Título <span class="req">*</span></label>
        <input type="text" name="titulo" required value="${escapeHtml(atual?.titulo || '')}" placeholder="ex: Cartões de ponto do período" />
      </div>
      <div class="lex-field">
        <label>Categoria</label>
        <select name="categoria">
          <option value="">—</option>
          <option value="contratual"   ${atual?.categoria === 'contratual' ? 'selected' : ''}>Contratual</option>
          <option value="jornada"      ${atual?.categoria === 'jornada' ? 'selected' : ''}>Jornada</option>
          <option value="medico"       ${atual?.categoria === 'medico' ? 'selected' : ''}>Médico</option>
          <option value="financeiro"   ${atual?.categoria === 'financeiro' ? 'selected' : ''}>Financeiro</option>
          <option value="operacional"  ${atual?.categoria === 'operacional' ? 'selected' : ''}>Operacional</option>
          <option value="outro"        ${atual?.categoria === 'outro' ? 'selected' : ''}>Outro</option>
        </select>
      </div>
      <div class="lex-field">
        <label>Status</label>
        <select name="status">
          ${Object.entries(STATUS_DOC).map(([v, info]) =>
            `<option value="${v}" ${atual?.status === v ? 'selected' : ''}>${info.txt}</option>`).join('')}
        </select>
      </div>
      <div class="lex-field">
        <label>Prazo</label>
        <input type="date" name="prazo" value="${atual?.prazo || ''}" />
      </div>
      <div class="lex-field">
        <label>Obrigatório?</label>
        <select name="obrigatorio">
          <option value="true"  ${atual?.obrigatorio !== false ? 'selected' : ''}>Sim</option>
          <option value="false" ${atual?.obrigatorio === false ? 'selected' : ''}>Não</option>
        </select>
      </div>
      <div class="lex-field lex-field--full">
        <label>Descrição</label>
        <textarea name="descricao" rows="2">${escapeHtml(atual?.descricao || '')}</textarea>
      </div>
      <div class="lex-field lex-field--full">
        <label>Link / URL externa (opcional)</label>
        <input type="url" name="arquivo_url" value="${escapeHtml(atual?.arquivo_url || '')}" placeholder="https://..." />
        <small class="hint">Upload pro Storage virá em fase posterior. Por ora, link externo.</small>
      </div>
    </div>
  `;
  const foot = document.createElement('div');
  foot.style.cssText = 'display:contents';
  foot.innerHTML = `
    <button type="button" class="lex-btn-secondary" data-act="cancel">Cancelar</button>
    <button type="submit" class="lex-btn" style="width:auto;padding:10px 18px">${atual ? 'Salvar' : 'Adicionar'}</button>
  `;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const fd = new FormData(form);
    const payload = {
      processo_id: processo.id,
      titulo: fd.get('titulo'),
      categoria: fd.get('categoria') || null,
      status: fd.get('status') || 'pendente',
      prazo: fd.get('prazo') || null,
      obrigatorio: fd.get('obrigatorio') === 'true',
      descricao: (fd.get('descricao') || '').trim() || null,
      arquivo_url: (fd.get('arquivo_url') || '').trim() || null,
    };
    try {
      if (atual) await atualizarDoc(atual.id, payload);
      else       await criarDoc(payload);
      closeModal();
      onDone();
    } catch (err) {
      alert('Erro: ' + (err.message || err));
    }
  });
  foot.querySelector('[data-act="cancel"]').addEventListener('click', closeModal);

  openModal({ title: atual ? 'Editar documento' : 'Novo documento', body: form, footer: foot });
}

// ════════════════════════════════════════════════════════════════════════
// 4. PLANO DE AÇÃO
// ════════════════════════════════════════════════════════════════════════
const STATUS_ACAO = {
  aberta:              { cls: 'lex-badge lex-badge-warn', txt: 'ABERTA' },
  em_andamento:        { cls: 'lex-badge lex-badge-info', txt: 'EM ANDAMENTO' },
  aguardando_externo:  { cls: 'lex-badge lex-badge-bronze', txt: 'AGUARDANDO' },
  concluida:           { cls: 'lex-badge lex-badge-ok',   txt: 'CONCLUÍDA' },
  cancelada:           { cls: 'lex-badge lex-badge-info', txt: 'CANCELADA' },
  superada:            { cls: 'lex-badge lex-badge-info', txt: 'SUPERADA' },
};
const PRIO_ACAO = {
  critica: { cls: 'lex-badge lex-badge-crit', txt: 'CRÍTICA' },
  alta:    { cls: 'lex-badge lex-badge-warn', txt: 'ALTA' },
  media:   { cls: 'lex-badge lex-badge-info', txt: 'MÉDIA' },
  baixa:   { cls: 'lex-badge lex-badge-ok',   txt: 'BAIXA' },
};

async function renderAcoes(host, processo, userEmail) {
  const rows = await fetchProcessoAcoes(processo.id);
  const abertas = rows.filter(a => !['concluida','cancelada','superada'].includes(a.status)).length;

  host.innerHTML = `
    <div class="lex-section">
      <h2>Plano de ação <span class="count">${abertas} aberta(s) / ${rows.length} total</span></h2>
      <div style="padding:14px 20px">
        ${rows.length ? `
          <table class="lex-table" style="font-size:13px">
            <thead><tr>
              <th>Tarefa</th><th>Responsável</th><th>Prazo</th>
              <th>Prio</th><th>Status</th><th></th>
            </tr></thead>
            <tbody>
              ${rows.map(a => {
                const st = STATUS_ACAO[a.status] || STATUS_ACAO.aberta;
                const pr = PRIO_ACAO[a.prioridade] || PRIO_ACAO.media;
                const concluida = ['concluida','cancelada','superada'].includes(a.status);
                return `
                  <tr style="${concluida ? 'opacity:0.55' : ''}">
                    <td>
                      <strong>${escapeHtml(a.titulo)}</strong>
                      ${a.tipo ? `<span class="lex-badge lex-badge-bronze" style="margin-left:6px">${escapeHtml(a.tipo)}</span>` : ''}
                      ${a.descricao ? `<br><span style="color:rgba(255,255,255,0.55);font-size:11px">${escapeHtml(a.descricao)}</span>` : ''}
                      ${a.resultado ? `<br><span style="color:#6FE0A8;font-size:11px">✓ ${escapeHtml(a.resultado)}</span>` : ''}
                    </td>
                    <td>${escapeHtml(a.responsavel?.nome || '—')}</td>
                    <td>${fmtDate(a.prazo)}</td>
                    <td><span class="${pr.cls}">${pr.txt}</span></td>
                    <td><span class="${st.cls}">${st.txt}</span></td>
                    <td style="white-space:nowrap">
                      ${!concluida ? `<button class="lex-btn-secondary" style="padding:5px 10px;font-size:11px" data-done="${a.id}">concluir</button>` : ''}
                      <button class="lex-btn-secondary" style="padding:5px 10px;font-size:11px" data-edit="${a.id}">editar</button>
                      <button class="lex-btn-secondary" style="padding:5px 10px;font-size:11px;border-color:#FF8C8C;color:#FF8C8C" data-rm="${a.id}">×</button>
                    </td>
                  </tr>`;
              }).join('')}
            </tbody>
          </table>
        ` : `<div class="lex-empty">Nenhuma ação no plano.</div>`}
        <div style="margin-top:14px">
          <button class="lex-btn-secondary" data-act="add-acao">+ Nova ação</button>
        </div>
      </div>
    </div>
  `;

  $$('[data-rm]', host).forEach(btn => btn.addEventListener('click', async () => {
    if (!confirm('Remover esta ação?')) return;
    await removerAcao(btn.dataset.rm);
    renderAcoes(host, processo, userEmail);
  }));
  $$('[data-edit]', host).forEach(btn => btn.addEventListener('click', () => {
    const acao = rows.find(r => r.id === btn.dataset.edit);
    abrirFormAcao(processo, acao, () => renderAcoes(host, processo, userEmail));
  }));
  $$('[data-done]', host).forEach(btn => btn.addEventListener('click', async () => {
    const resultado = prompt('Resultado / observação ao concluir esta ação?', '');
    if (resultado === null) return;
    await concluirAcao(btn.dataset.done, resultado || 'Concluída', userEmail);
    renderAcoes(host, processo, userEmail);
  }));
  $('[data-act="add-acao"]', host).addEventListener('click', () =>
    abrirFormAcao(processo, null, () => renderAcoes(host, processo, userEmail))
  );
}

async function abrirFormAcao(processo, atual, onDone) {
  const pessoas = await fetchPessoas();
  const form = document.createElement('form');
  form.innerHTML = `
    <div class="lex-form-grid">
      <div class="lex-field lex-field--full">
        <label>Título <span class="req">*</span></label>
        <input type="text" name="titulo" required value="${escapeHtml(atual?.titulo || '')}" placeholder="ex: Coletar cartões de ponto" />
      </div>
      <div class="lex-field">
        <label>Tipo</label>
        <select name="tipo">
          <option value="">—</option>
          ${['coleta_documento','redacao_peca','audiencia','reuniao_estrategia','protocolo','contato_externo','provisao_financeira','outro'].map(t =>
            `<option value="${t}" ${atual?.tipo === t ? 'selected' : ''}>${t}</option>`
          ).join('')}
        </select>
      </div>
      <div class="lex-field">
        <label>Prioridade</label>
        <select name="prioridade">
          <option value="baixa"   ${atual?.prioridade === 'baixa' ? 'selected' : ''}>Baixa</option>
          <option value="media"   ${atual?.prioridade === 'media' || !atual ? 'selected' : ''}>Média</option>
          <option value="alta"    ${atual?.prioridade === 'alta' ? 'selected' : ''}>Alta</option>
          <option value="critica" ${atual?.prioridade === 'critica' ? 'selected' : ''}>Crítica</option>
        </select>
      </div>
      <div class="lex-field">
        <label>Prazo</label>
        <input type="date" name="prazo" value="${atual?.prazo || ''}" />
      </div>
      <div class="lex-field">
        <label>Status</label>
        <select name="status">
          ${Object.entries(STATUS_ACAO).map(([v, info]) =>
            `<option value="${v}" ${atual?.status === v ? 'selected' : ''}>${info.txt}</option>`).join('')}
        </select>
      </div>
      <div class="lex-field lex-field--full">
        <label>Responsável</label>
        <select name="responsavel_pessoa_id">
          <option value="">—</option>
          ${pessoas.map(p => `<option value="${p.id}" ${atual?.responsavel_pessoa_id === p.id ? 'selected' : ''}>${escapeHtml(p.nome)} · ${escapeHtml(p.papel || '')}</option>`).join('')}
        </select>
      </div>
      <div class="lex-field lex-field--full">
        <label>Descrição</label>
        <textarea name="descricao" rows="2">${escapeHtml(atual?.descricao || '')}</textarea>
      </div>
    </div>
  `;
  const foot = document.createElement('div');
  foot.style.cssText = 'display:contents';
  foot.innerHTML = `
    <button type="button" class="lex-btn-secondary" data-act="cancel">Cancelar</button>
    <button type="submit" class="lex-btn" style="width:auto;padding:10px 18px">${atual ? 'Salvar' : 'Adicionar'}</button>
  `;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const fd = new FormData(form);
    const payload = {
      processo_id: processo.id,
      titulo: fd.get('titulo'),
      tipo: fd.get('tipo') || null,
      prioridade: fd.get('prioridade') || 'media',
      status: fd.get('status') || 'aberta',
      prazo: fd.get('prazo') || null,
      responsavel_pessoa_id: fd.get('responsavel_pessoa_id') || null,
      descricao: (fd.get('descricao') || '').trim() || null,
    };
    try {
      if (atual) await atualizarAcao(atual.id, payload);
      else       await criarAcao(payload);
      closeModal();
      onDone();
    } catch (err) {
      alert('Erro: ' + (err.message || err));
    }
  });
  foot.querySelector('[data-act="cancel"]').addEventListener('click', closeModal);

  openModal({ title: atual ? 'Editar ação' : 'Nova ação', body: form, footer: foot });
}
